meedy.filter('meedyUpperCaseFirstLetterFilter', ['$translate', function ($translate) {
    return function (input) {
        if(input) {
            return input.charAt(0).toUpperCase() + input.substr(1).toLowerCase();
        } else {
            return ''
        }
    };
}]);